import { DEFAULT_VIEW } from '@databases/collab/utils';
import { type YDatabase } from '@databases/collab/y-database';
import { messages } from '@databases/intl/messages';
import { type DatabaseViewJSON } from '@databases/model/views/view';
import type { IntlShape } from 'react-intl-next';
import { v4 as uuidv4 } from 'uuid';

/**
 * This migration creates a default view for new databases.
 */
export const initialView = {
  version: 1725574719190, // timestamp of the migration when it's written
  apply(documentId: string, ydb: YDatabase, intl: IntlShape) {
    if (ydb.views.length > 0) {
      return;
    }

    const defaultViewId = uuidv4();
    const defaultView: DatabaseViewJSON = {
      ...DEFAULT_VIEW,
      name: `${intl.formatMessage(messages['view.default-view-name'])} 1`,
    };

    ydb.mutate(() => {
      ydb.addView(defaultViewId, defaultView);
      ydb.defaultViewId = defaultViewId;
    });
  },
};
